import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ErrorsTooltipProps {
  errors: string[];
}

const ErrorsTooltip = ({ errors }: ErrorsTooltipProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <b>{t('pages.bidSheet.errors.header', { count: errors.length })}</b>
      <ul>
        {errors.map((error, i) => (
          <li key={i}>{error}</li>
        ))}
      </ul>
    </div>
  );
};

export default ErrorsTooltip;
